import {useReducer} from 'react';
import PayRollIncidentContext, {initialState} from "./PayRollIncidentContext";
import PayRollIncidentReducer from './PayRollIncidentReducer';

const PayRollIncidentState = (props:any) => {
    const [state,dispatch] = useReducer(PayRollIncidentReducer, initialState)
    return (
        <PayRollIncidentContext.Provider value={{state,dispatch}}>
                  {props.children}
        </PayRollIncidentContext.Provider>
    )
}

export default PayRollIncidentState;